/**
 * Validation utilities for form inputs
 */

/**
 * Validates if a string is a valid GUID format
 * @param value The string to validate
 * @returns True if the value is a valid GUID format, false otherwise
 */
export const isValidGuid = (value: string): boolean => {
  if (!value) return false;

  // GUID format: xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx
  // where M is 1-5 (version) and N is 8, 9, A, or B (variant)
  const guidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

  return guidRegex.test(value.trim());
};
